export default __webpack_public_path__ + "static/media/054-direction.ef3625e0.png";